export const getHtmlBody = (string) => {
    let body;
    if (string.indexOf('<body') > -1) {
        body = string.match(/<body[^>]*>[\s\S]*<\/body>/gi).toString();
    } else {
        body = string;
    }
    return body;
};
